
import { ProgressBar } from 'react-bootstrap';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useSelector } from 'react-redux';
import "./PercentSuccessV2.css"

function PercentSuccessV2({ percent }) {

    const stateSize = useSelector((state) => state.size);

    return (
        <>
            {
                stateSize.windowWidth > 1000 ? (
                    <div style={{ height: "50px", width: "50px" }}>
                        <CircularProgressbar value={percent} text={`${percent}%`} styles={buildStyles({ pathColor: `rgba(63, 180, 90, ${percent / 100})`, textColor: '#495057', })} />
                    </div>
                ) :
                    (
                        <div className='progressbar_block'>
                            <div className='progressbar' style={{ width: percent + '%', backgroundColor: `rgba(63, 180, 90, ${percent / 100})` }}>{percent}%</div>
                        </div>
                    )
            }
        </>

    )
}

export default PercentSuccessV2;